export default function getPercent(coef: number): string {
  return Math.round((coef - 1) * 100) + '%';
}
